import router from './router/index'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'// progress bar style
import { some, map } from 'lodash';

NProgress.configure({ showSpinner: false })// NProgress Configuration

// permissiom judge function
function hasPermission(roles, permissionRoles) {
  if (roles.indexOf('admin') >= 0) return true // admin permission passed directly
  if (!permissionRoles) return true
  return roles.some(role => permissionRoles.indexOf(role) >= 0)
}

// 登录验证
function notLoginFn(isIgnore, next) {
  if (isIgnore === false) {
    next({
      name: 'user_login'
    });
  } else {
    next(true);
  }
}
router.beforeEach((to, from, next) => {
  NProgress.start() // start progress bar
  if (store.getters.getUserInfo.id) {
    // 没有动态改变权限的需求可直接next() 删除下方权限判断 ↓
    if (hasPermission(map(store.getters.getUserInfo.roles, 'name'), to.meta.roles)) {
      next(true);
    } else {
      next({
        name: 'error_401',
        replace: true,
        query: { noGoBack: true }
      });
    }
    // 可删 ↑
  } else if (store.getters.getUserInfo._state === 'fetched') {
    notLoginFn(!!(to.matched.length && to.meta.login !== true), next);
  } else {
    return store.dispatch('GetUserInfo').then((result) => {
      return store.dispatch('GenerateRoutes', {roles: map(result.roles, 'name')}).then(() => { // 根据roles权限生成可访问的路由表
        router.addRoutes(store.getters.addRouters); // 动态添加可访问路由表
        // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
        next({
          ...to,
          replace: true
        });
      })
    }).catch(() => {
      store.dispatch('FedLogOut').then(() => {
        notLoginFn(!!(to.matched.length && to.meta.login !== true), next);
      });
    });
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})



// WEBPACK FOOTER //
// ./src/permission.js